import home from "../Images/Assets/assets6.jpg"
import n1 from "../Images/Assets/Incubation.jpg"
import n2 from "../Images/Assets/Anganwadis.jpg"
import n3 from "../Images/Assets/spellstrikers.jpg"
import Marketathon from './Assets/banner-bg.jpg'; 

const images = { home, n1, n2, n3, Marketathon };

export default images;
